const state = {
    selectedBudget: null,//stores the selected client(used in form modal)
    budgetShow: false, //show=true | edit=false
    formBudget: null,
    showBudgetModal: false,//controls if the form modal is displayed or not
};

const getters = {
    getSelectedBudget(state, getters){
        if(!state.selectedBudget){
            state.selectedBudget = getters.getNewBudget;
        }
        return state.selectedBudget;
    },
    getFormBudget(state, getters){
        if(!state.formBudget){
            state.formBudget = getters.getEmptyFormBudget;
        }
        return state.formBudget;
    },
    getBudgetShow(state){
        return state.budgetShow;
    },
    getShowBudgetModal(state){
        return state.showBudgetModal;
    },

    getNewBudget(){
        return {
            id: '',
            code: '',
            name: '',
            companies_id: '',
            types_id: '',
            bar_code: '',
            price: '',
            unity: '',
            active_state: '',
            stock: '',
            min_stock: '',
            category: '',
            subcategory: '',
            description: '',
            budget_type_name: '',
            created_at: '',
        };
    },

    getEmptyFormBudget(){
        return {
            id: '',
            name: '',
            types_id: '',
            bar_code: '',
            price: '',
            unity: '',
            active_state: '',
            stock: '',
            min_stock: '',
            category: '',
            subcategory: '',
            companies_id: '',
            description: '',
        }
    }
};

const mutations = {
    setSelectedBudget(state, payload){ //this also works for new budget
        state.selectedBudget = payload;
    },
    setBudgetShow(state, payload){ //this also works for new budget
        state.budgetShow = payload;
    },
    setShowBudgetModal(state, payload){
        state.showBudgetModal = payload;
    },
};

const actions = {
    setSelectedBudget({commit}, payload){
        commit('setSelectedBudget', payload);
    },
    setBudgetShow({commit}, payload){
        commit('setBudgetShow', payload);
    },
    setShowBudgetModal({commit}, payload){
        commit('setShowBudgetModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

